import { Pipe, PipeTransform } from "@angular/core";
import { TaskType } from "@models/task-request";

@Pipe({
  name: "taskType",
  standalone: true,
})
export class TaskTypePipe implements PipeTransform {
  private readonly labels: Record<TaskType, string> = {
    [TaskType.EVENT_CREATION]: "Criação de Evento",
    [TaskType.EVENT_CANCELLATION]: "Cancelamento de Evento",
    [TaskType.WITHDRAWAL]: "Saque",
    [TaskType.REFUND]: "Reembolso",
    [TaskType.BANK_ACCOUNT_UPDATE]: "Alteração de Dados Bancários",
  };

  transform(value: TaskType): string {
    return this.labels[value] ?? value;
  }
}
